import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PATIENTUSERDETAILS_INIT_ACTION,
  FETCH_PATIENTUSERDETAILS_SUCCESS_ACTION,
  FETCH_PATIENTUSERDETAILS_FAIL_ACTION,
  FETCH_PATIENTINACTIVE_INIT_ACTION,
  FETCH_PATIENTINACTIVE_SUCCESS_ACTION,
  FETCH_PATIENTINACTIVE_FAIL_ACTION,
  FETCH_PATIENTDETAILSVIEW_INIT_ACTION,
  FETCH_PATIENTDETAILSVIEW_SUCCESS_ACTION,
  FETCH_PATIENTDETAILSVIEW_FAIL_ACTION,
  FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION,
  FETCH_PATIENTPRESCRIPTIONVIEW_SUCCESS_ACTION,
  FETCH_PATIENTPRESCRIPTIONVIEW_FAIL_ACTION
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchPatientUser(value) {
  const token = localStorage.getItem("token");
  
  let pageno = (!(value.value)) ? 1 : (value.value.pageno === undefined ? 1 : value.value.pageno);
  let filter = (!(value.value)) ? "" : (value.value.filter === "" ? "" : value.value.filter);
  let search = (!(value.value)) ? "" : (value.value.search === "" ? "" : value.value.search);

  try {
    const res = yield fetch(
      `${appConfig.ip}/users?role=patient&limit=10&page=${pageno}&status=${filter}&search=${search}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PATIENTUSERDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTUSERDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchpatientdetailview(value) {
  let id = value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/patientProf/` + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PATIENTDETAILSVIEW_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTDETAILSVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchPatientsInActive(data) {
  let datas = (data.value.item.status==="active")?{status:"suspended"}:{status:"active"};
  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_PATIENTINACTIVE_SUCCESS_ACTION,
        payload: resJSON
      });

      yield put({
        type: FETCH_PATIENTUSERDETAILS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTINACTIVE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchpatientprescriptionview(value) {
  let pageno = (!value.value)? 1: (value.value.page === undefined? 1: value.value.page);
  let id = value.value.item.item.id && value.value.item.item.id;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/prescriptionProf?userId=${id}&limit=5&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_PATIENTPRESCRIPTIONVIEW_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_PATIENTPRESCRIPTIONVIEW_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}

export function* PatientsActionWatcher() {
  yield takeEvery(FETCH_PATIENTUSERDETAILS_INIT_ACTION, fetchPatientUser);
  yield takeEvery(FETCH_PATIENTDETAILSVIEW_INIT_ACTION, fetchpatientdetailview);
  yield takeEvery(FETCH_PATIENTINACTIVE_INIT_ACTION, fetchPatientsInActive);
  yield takeEvery(FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION, fetchpatientprescriptionview);
}
